import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { BookingDetails } from '@/hooks/bookings/types';
import BookingViewTab from './BookingViewTab';
import QuotesTab from './QuotesTab';
import ActivityTab from './ActivityTab';
interface BookingDetailsTabsProps {
  booking: BookingDetails;
  quotes: any[];
  onQuoteUpdate: () => Promise<void>;
  onBookingUpdate?: (bookingId: string) => Promise<void>;
  isAdmin: boolean;
  isBookingOwner: boolean;
  defaultTab?: string;
}
export const BookingDetailsTabs = ({
  booking,
  quotes,
  onQuoteUpdate,
  onBookingUpdate,
  isAdmin,
  isBookingOwner,
  defaultTab = 'details'
}: BookingDetailsTabsProps) => {
  return <Tabs defaultValue={defaultTab} className="h-full flex flex-col">
      <div className="relative border-b border-border">
        <TabsList className="mx-4 md:mx-6 my-0 grid w-[calc(100%-2rem)] md:w-[calc(100%-3rem)] grid-cols-3">
          <TabsTrigger value="details" className="px-3 md:px-4">
            Details
          </TabsTrigger>
          <TabsTrigger value="quotes" className="px-3 md:px-4">
            Quotes
          </TabsTrigger>
          <TabsTrigger value="activity" className="px-3 md:px-4">
            Activity
          </TabsTrigger>
        </TabsList>
      </div>

      <div className="flex-1 overflow-auto px-2 md:px-0">
        <TabsContent value="details" className="mt-0 h-full">
          <BookingViewTab booking={booking} quotes={quotes} onQuoteUpdate={onQuoteUpdate} onBookingUpdate={onBookingUpdate} isAdmin={isAdmin} isBookingOwner={isBookingOwner} className="py-[20px]" />
        </TabsContent>

        <TabsContent value="quotes" className="mt-0 h-full">
          <QuotesTab booking={booking} quotes={quotes} onQuoteUpdate={onQuoteUpdate} onBookingUpdate={onBookingUpdate} isAdmin={isAdmin} isBookingOwner={isBookingOwner} />
        </TabsContent>

        <TabsContent value="activity" className="mt-0 h-full">
          <ActivityTab booking={booking} />
        </TabsContent>
      </div>
    </Tabs>;
};